import { FormatConstants } from "services/keyConstants";
import { getMasterDocDataByKey } from "services/ReduxUtils";

export const getStatusTypes = (type) => {
  switch (type) {
  
    case FormatConstants.CUSTOMERSERVICE.CUSTOMER_SERVICING_DETAILS:
      return {
        filteredData: {
          page: 1,
          totalPage: 1,
          isSpecialCase: false,
          status: getMasterDocDataByKey({
            defaultName:
              FormatConstants.CUSTOMERSERVICE.CUSTOMER_SERVICING_DETAILS,
          })?.masterDocId,
        },
        defaultOptionData: {
          statusOptions: [
            {
              label: "Servicing",
              value: getMasterDocDataByKey({
                defaultName:
                  FormatConstants.CUSTOMERSERVICE.CUSTOMER_SERVICING_DETAILS,
              })?.masterDocId,
            },
            {
              label: "Complaint",
              value: getMasterDocDataByKey({
                defaultName: FormatConstants.COMPLAINT.CUSTOMER_COMPLAINT_FORM,
              })?.masterDocId,
            },
          ],
          typeOptions: [
            { label: "All", value: undefined },
            { label: "Internal", value: "Internal" },
            {
              label: "External",
              value: "External",
            },
          ],
        },
      };
      break;

    case FormatConstants.CUSTOMERSERVICE.CUSTOMER_SERVICING_FORM:
      return {
        filteredData: {
          page: 1,
          totalPage: 1,
        },
        defaultOptionData: {
          typeOptions: [
            { label: "All", value: undefined },
            { label: "Internal", value: "Internal" },
            { label: "External", value: "External" },
          ],
        },
      };
      break;

    case FormatConstants.CUSTOMERSERVICE.CUSTOMER_SERVICING_FEEDBACK:
      return {
        filteredData: {
          page: 1,
          totalPage: 1,
        },
        defaultOptionData: {
          typeOptions: [
            { label: "All", value: undefined },
            { label: "Internal", value: "Internal" },
            { label: "External", value: "External" },
          ],
        },
      };
      break;

    default:
      return {
        filteredData: {},
        defaultOptionData: {
          statusOptions: [],
        },
      };
  }
};
